import { forwardRef } from 'react';
import { ButtonProps as AButtonProps } from 'antd';
import { TestProps } from 'core/utils/testTypes';
import {
    StyledAssignButton,
    StyledDefaultButton,
    StyledErrorButton,
    StyledLinkButton,
    StyledPrimaryButton,
    StyledOutlinedButton,
    StyledSuccessButton,
} from './styles';
import { UserAddOutlined } from '@ant-design/icons';

export interface ButtonProps extends Omit<AButtonProps, 'type'>, TestProps {
    type?: 'primary' | 'default' | 'error' | 'dashed' | 'link' | 'text' | 'success' | 'assign' | 'outlined';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(({ type, ...rest }, ref) => {
    switch (type) {
        case 'primary':
            return <StyledPrimaryButton ref={ref} {...rest} />;
        case 'error':
            return <StyledErrorButton ref={ref} {...rest} />;
        case 'link':
            return <StyledLinkButton ref={ref} {...rest} />;
        case 'success':
            return <StyledSuccessButton ref={ref} {...rest} />;
        case 'outlined':
            return <StyledOutlinedButton ref={ref} {...rest} />;
        case 'assign':
            return (
                <StyledAssignButton
                    size="small"
                    icon={
                        <UserAddOutlined
                            style={{
                                color: 'currentColor',
                            }}
                        />
                    }
                    {...rest}
                >
                    Assign
                </StyledAssignButton>
            );
        default:
            return <StyledDefaultButton ref={ref} {...rest} />;
    }
});

Button.displayName = 'Button';
export default Button;
